module.exports = __webpack_public_path__ + "static/media/features3_1.d400e04f.png";